import React from 'react';
import { Image, Skeleton } from '@round/ui-kit';
import styles from './TiktokUserBadge.module.css';

type Props = {
    isLoading: boolean;
    data: UserData;
};

export type UserData = {
    nickname: string;
    username: string;
    profileUrl: string;
    imageUrl: string;
};

const TiktokUserBadge = ({ isLoading, data }: Props) => {
    // fallback to an empty object to handle skeleton rows.
    // skeleton rows are empty objects, which causes destructuring of undefined error
    const { nickname, username, profileUrl, imageUrl } = data || {};

    return (
        <div className={styles.container}>
            <Image loading={isLoading} className={styles.image} src={imageUrl} alt={nickname} />
            <div className={styles.details}>
                <span className={styles.nickname}>{isLoading ? <Skeleton width="100%" /> : nickname}</span>
                <a
                    className={styles.username}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!profileUrl) {
                            return false;
                        }
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={profileUrl}
                >
                    {isLoading ? <Skeleton width="70%" /> : username}
                </a>
            </div>
        </div>
    );
};

export default TiktokUserBadge;
